import awsmobile from '@/aws-exports';
import Utils from '@/common/utils/utils';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { uploadFileToS3InTMPFolder } from '@/common/utils/UploadFileUtil'; 
import { Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useEffect, useState, useRef } from 'react';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Constant from '../../../common/constant/Constant';
import { getLinkDownloadFileFromS3 } from '../../common/FileUploaded';
import './RichTextUI.css';
import SpecialCharactersEmoji from './SpecialCharactersEmoji';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import LoadingPanel from '@/component/common/LoadingPanel';
import { pushClientLog } from '@/service/logService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { PropTypes } from 'prop-types';

function getImageSrc(htmlString) {
    let doc;
    try {
        doc = new DOMParser().parseFromString(htmlString, "text/html");
    } catch (e) {
        return [];
    }
    
    const img = doc.querySelectorAll("img");
    const imgSrcList = [];
    if (img) {
        doc.querySelectorAll('img').forEach((imgElement) => {
        imgSrcList.push(imgElement.getAttribute('src'));
        });
    }
    return imgSrcList;
}

const replaceOldLinkImg = defaultValue => {
    let stringCopy = (' ' + defaultValue).slice(1);

    let imgSrcList = getImageSrc(defaultValue);
    imgSrcList = imgSrcList.filter(src => src);
    if(Utils.isEmptyArray(imgSrcList)) {
        return stringCopy;
    }

    for (let i = 0; i < imgSrcList.length; i++) {
        let indexOfImage = imgSrcList[i].indexOf(
            `https://${awsmobile.aws_user_files_s3_bucket}.s3`
        );
        if (indexOfImage !== -1) {
            const startStr = '/public/';
            const endStr = '?';

            const startIndex = imgSrcList[i].indexOf(startStr) + startStr.length;
            const endIndex = imgSrcList[i].indexOf(endStr, startIndex);

            const resultKey = imgSrcList[i].substring(startIndex, endIndex);
            
            let fileUpload = {
                fileUrl: resultKey,
                type: Constant.S3_FILE_TYPE.TICKET_FILE
            }
            let link = getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
            let linkNeedReplace = `\\"${link}\\"`;
            stringCopy = stringCopy.replace(imgSrcList[i], linkNeedReplace);
        }
    }
    return stringCopy;
};

RichTextEditor.propTypes = {
    defaultValue: PropTypes.any,
    parentForm: PropTypes.any,
    flagReset: PropTypes.any,
    data: PropTypes.any,
    viewFromProjectOfEscalateTicket: PropTypes.any,
    detailTicket: PropTypes.any,
    hasEditFieldPermissions: PropTypes.any,
};

  
export default function RichTextEditor(props) {
    const [errMsg, setErrMsg] = useState('');
    const [selftCKEditor5, setSelftCKEditor5] = useState(null);

    const [isLoadingUploadFile, setIsLoadingUploadFile] = useState(false);
    let defaultValueNew =  props?.defaultValue ? replaceOldLinkImg(props?.defaultValue) : JSON.stringify('');
    const [ckEditorState, setCKEditorState] = useState(Utils.isValidJSONString(defaultValueNew) ? JSON.parse(defaultValueNew) : defaultValueNew);
    const ckEditorId = Utils.generateRandomStr();
    const timeStampDefault = new Date().getTime();


    const [errorLogQueue, setErrorLogQueue] = useState([]);
    const isThrottled = useRef(false);
    const contextualBalloonOriginalMethods = useRef(null);

    useEffect(() => {
        let replaceValue =  props?.defaultValue ? replaceOldLinkImg(props?.defaultValue) : JSON.stringify('');
        let defaultValue = Utils.isValidJSONString(replaceValue) ? JSON.parse(replaceValue) :  replaceValue;
        setCKEditorState(defaultValue);
    }, [props?.defaultValue, props.parentForm, props.flagReset]);



    useEffect(() => {
        props.register(props?.name);
        if (props?.defaultValue) {
            props.setValue(
                props?.name,
                JSON.stringify(ckEditorState)
            );
        } else {
            props.setValue(props?.name, '');
        }

        const handleError = (event) => {
            const errorInfo = {
                message: event.message,
                source: event.filename,
                lineno: event.lineno,
                colno: event.colno,
                error: event.error ? event.error.stack : null,
                defaultValue: props?.defaultValue ? JSON.stringify(props?.defaultValue) : ''
            };

            setErrorLogQueue((prevQueue) => [...prevQueue, errorInfo]);
        };

        const handleUnhandledRejection = (event) => {
            const errorInfo = {
                message: event.reason?.message || 'Unhandled promise rejection',
                stack: event.reason?.stack || null,
            };

            setErrorLogQueue((prevQueue) => [...prevQueue, errorInfo]);
        };

        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleUnhandledRejection);
        
        return () => {
            setErrMsg('');
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        }
    }, []);

    useEffect(()=>{
        props.register(props?.name);
    }, [props?.data])


    useEffect(() => {
        if (!isThrottled.current && errorLogQueue.length > 0) {
            const logsToSend = errorLogQueue.slice(0, 50);
            const combinedLogs = {
                timestamp: new Date().toISOString(),
                errors: logsToSend, 
            };
            pushClientLog(combinedLogs, {
                corpDomain: localStorageUtil.getCorporationDomain(),
                name: 'RichTextEditorError'
            });

            setErrorLogQueue([]);

            isThrottled.current = true;

            setTimeout(() => {
                isThrottled.current = false;
            }, 60000); 
        }
    }, [errorLogQueue]);

    const handleErrorTryCatch = (fn, error) => {
        let errorInfo = {
            fn: fn,
            statck: error?.stack,
            message: error?.message
        }

        setErrorLogQueue((prevQueue) => [...prevQueue, errorInfo]);
    }


    useEffect(() => {
        try {
            props.setValue(
                props?.name,
                JSON.stringify(ckEditorState)
            );
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();

            // For email reply screen
            if (props.triggerEnableBtnSaveTicket) {
                props.triggerEnableBtnSaveTicket();
            }
        } catch (error) {
            handleErrorTryCatch('useEffect 1', error)
        }
        
        
    }, [ckEditorState]);


    const publicForCustomer = props.data.structure.publicForCustomer;

    const isRichtextReadOnly = () => {
        const flag =
        props.data.structure.publicForCustomer == 2
        || props.viewFromProjectOfEscalateTicket
        || !Utils.isEmptyString(props.detailTicket?.deletedAt)
        || props.hasEditFieldPermissions == false;
        return flag;
    }

    useEffect(() => {
        try {
            let newMsg = '';
            if (props.errorlist && props.errorlist.hasOwnProperty(props?.name)) {
                newMsg = props.errorlist[props?.name].message
            }
            if(!Utils.isEmptyObject(props.data?.error)) {
                newMsg = props.data?.error?.message
            }
            setErrMsg(newMsg);
        } catch (error) {
            handleErrorTryCatch('useEffect 2', error)
        }
       
    }, [props.errorlist, props.data?.error]);

    useEffect(() => {
        try {
            if (props?.defaultValue) {
                props.setValue(
                    props?.name,
                    JSON.stringify(Utils.isValidJSONString(defaultValueNew) ? JSON.parse(defaultValueNew) : '')
                );
            } else {
                props.setValue(
                    props?.name,
                    ''
                );
            }

            if (props?.setFlagReset) {
                props.setFlagReset(false)
            }

            return () => {
                if (props?.setFlagReset) {
                    props.setFlagReset(false)
                }
            }
        } catch (error) {
            handleErrorTryCatch('useEffect 3', error)
        }
            

            
    }, [props?.flagReset]);


    useEffect(() => {
        try {
            const elem = document.querySelector(`.custom-class${timeStampDefault}`);
        if (elem) {
            let visible = window?.getComputedStyle(elem)?.getPropertyValue('visibility');
            let elemUploadFile = elem.querySelector('.rdw-image-modal-upload-option');
            if(elemUploadFile) {
                elemUploadFile.addEventListener('click', () =>{
                    elem.style.display = 'flex';
                })
            }
            if (visible === 'visible') {
                elem.style.display = 'flex';
            } else {
                elem.style.display = 'none';
            }
        }
        } catch (error) {
            handleErrorTryCatch('useEffect 4', error)
        }
        

        
    });

    useEffect(() => {
        try {
            const isReadOnly = isRichtextReadOnly()
            if (isReadOnly) {
                if (selftCKEditor5 && selftCKEditor5.isReadOnly == false) {
                    selftCKEditor5.enableReadOnlyMode(selftCKEditor5.id);
                }
                // Hide balloon toolbar when switching to readonly mode
                if (selftCKEditor5 && contextualBalloonOriginalMethods.current) {
                    try {
                        const contextualBalloon = selftCKEditor5.plugins.get('ContextualBalloon');
                        if (contextualBalloon && contextualBalloon.view) {
                            contextualBalloon.view.hide();
                            // Override methods to prevent balloon from showing
                            contextualBalloon.showStack = () => {};
                            contextualBalloon.add = () => {};
                        }
                    } catch (e) {
                        // Plugin may not exist
                    }
                }
            } else {
                if (selftCKEditor5 && selftCKEditor5.isReadOnly == true) {
                    selftCKEditor5.disableReadOnlyMode(selftCKEditor5.id);
                }
                // Restore balloon toolbar methods when switching to edit mode
                if (selftCKEditor5 && contextualBalloonOriginalMethods.current) {
                    try {
                        const contextualBalloon = selftCKEditor5.plugins.get('ContextualBalloon');
                        if (contextualBalloon) {
                            contextualBalloon.showStack = contextualBalloonOriginalMethods.current.showStack;
                            contextualBalloon.add = contextualBalloonOriginalMethods.current.add;
                        }
                    } catch (e) {
                        // Plugin may not exist
                    }
                }
            }
        } catch (error) {
            handleErrorTryCatch('useEffect 5', error)
        }
        
    });


    const handleOnChangeCKEditor = (event, editor) => {
        try {
            const isReadOnly = isRichtextReadOnly()
            if (isReadOnly) return;
            const htmlContent = editor.getData();
            setCKEditorState(htmlContent);
            props?.setValue(
                props?.name,
                JSON.stringify(htmlContent)
            );
            if (props?.setIsEdited) {
                props?.setIsEdited(true);
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
                if (!props?.listFieldEdited?.includes(props?.name)) {
                    props?.setListFieldEdited([...props?.listFieldEdited,props?.name]);
                }
                if (props?.setOnChangeEdit) {
                    props?.setOnChangeEdit(!props.onChangeEdit);
                }
            }

            // validateRichTextField(htmlContent);
            let contentText = getRichTextFieldContent(htmlContent);
            const validateSizeRichtextContent = JSON.stringify(htmlContent)
            let newErrMsg =
                (props.data?.structure?.required && !contentText)
                ? I18n.get('COMM01MSG11')
                : Utils.validateSizeOfFieldTicket(validateSizeRichtextContent);
            setErrMsg(newErrMsg);

        } catch (error) {
            handleErrorTryCatch('handleOnChangeCKEditor', error)
        }
        
    }

    /**
     * Custom image upload to S3 storage.
     * 
     * Ref: https://ckeditor.com/docs/ckeditor5/latest/framework/deep-dive/upload-adapter.html
     */
    function uploadImageAdapterPlugin(editor) {
        try {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return handleUploadImageAdapter(loader);
            };
        } catch (error) {
            handleErrorTryCatch('uploadImageAdapterPlugin', error)
        }
        
    }


    const handleUploadImageAdapter = (loader) => {
        return {
            upload: async () => {
                return loader.file.then((file)=>{
                    setIsLoadingUploadFile(true)
                    return file
                }).then(async (file) => {
                    const result = await uploadFileToS3InTMPFolder(file);
                    let fileUpload = {
                        fileUrl: result.key,
                        type: Constant.S3_FILE_TYPE.TICKET_FILE
                    };
                    let link = await getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
                    return {
                        default: `${link}`
                    };
                }).finally( ()=>{
                   setTimeout(()=> setIsLoadingUploadFile(false), 600)
                });
            }
        };
    }

    const editorConfiguration = {
        language: 'en',
        font_defaultLabel: 'Arial, Helvetica, sans-serif',
        placeholder: '',
        extraPlugins: [
            SpecialCharactersEmoji,
            uploadImageAdapterPlugin
        ],
        // https://ckeditor.com/docs/ckeditor5/latest/features/toolbar/toolbar.html#extended-toolbar-configuration-format
        toolbar: {
            items: [
                {
                    label: 'More basic styles',
                    icon: 'bold',
                    items: ['bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', 'removeFormat',]
                },
                'heading', '|',
                'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
                'bulletedList', 'alignment', 'todoList', 'numberedList', '|',
                'insertTable', 'specialCharacters', 'link', 'mediaEmbed', 'uploadImage', 'insertImage', 'htmlEmbed', '|',
                'undo', 'redo', 'blockQuote', 'codeBlock'
            ],
            shouldNotGroupWhenFull: true
        },
        mediaEmbed: {
            removeProviders: [
                'instagram',
                'twitter',
                'googleMaps',
                'flickr',
                'facebook'
            ]
        },
        image: {
            styles: [
                'alignCenter',
                'alignLeft',
                'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'resizeImage:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'resizeImage:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'resizeImage:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageTextAlternative', 'toggleImageCaption', '|',
                'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText', '|',
                'resizeImage'
            ]
        },
        table: {
            contentToolbar: [
                'tableColumn',
                'tableRow',
                'mergeTableCells',
                'tableProperties',
                'tableCellProperties'
            ],

        },
        list: {
            properties: {
                styles: true,
                startIndex: true,
                reversed: true
            }
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/headings.html#configuration
        heading: {
            options: [
                { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
            ]
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-family-feature
        fontFamily: {
            options: [
                // 'Arial',
                'Arial, Helvetica, sans-serif',
                'Georgia, serif',
                'Tahoma, Geneva, sans-serif',
                'Times New Roman, Times, serif',
                'Trebuchet MS, Helvetica, sans-serif',
                'Verdana, Geneva, sans-serif'
            ],
            supportAllValues: true
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-size-feature
        fontSize: {
            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
            supportAllValues: true,
        },
        // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
        // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
        htmlSupport: {
            allow: [
                {
                    name: /.*/,
                    attributes: true,
                    classes: true,
                    styles: true
                }
            ]
        },
        // Be careful with enabling previews
        // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
        htmlEmbed: {
            showPreviews: true
        },
        // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
        link: {
            decorators: {
                openInNewTab: {
                    mode: 'manual',
                    label: 'Open in a new tab',
                    defaultValue: true,
                    attributes: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            }
        },
        // The "superbuild" contains more premium features that require additional configuration, disable them below.
        // Do not turn them on unless you read the documentation and know how to configure them and setup the editor.
        removePlugins: [
            // These two are commercial, but you can try them out without registering to a trial.
            // 'ExportPdf',
            // 'ExportWord',
            'AIAssistant',
            'CKBox',
            'CKFinder',
            'EasyImage',
            // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
            // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
            // Storing images as Base64 is usually a very bad idea.
            // Replace it on production website with other solutions:
            // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
            'Base64UploadAdapter',
            'MultiLevelList',
            'RealTimeCollaborativeComments',
            'RealTimeCollaborativeTrackChanges',
            'RealTimeCollaborativeRevisionHistory',
            'PresenceList',
            'Comments',
            'TrackChanges',
            'TrackChangesData',
            'RevisionHistory',
            'Pagination',
            // Requires additional license key
            'WProofreader',
            // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
            // from a local file system (file://) - load this site via HTTP server if you enable MathType.
            'MathType',
            // The following features are part of the Productivity Pack and require additional license.
            'SlashCommand',
            'Template',
            'DocumentOutline',
            'FormatPainter',
            'TableOfContents',
            'PasteFromOfficeEnhanced',
            'CaseChange'
        ],
         font_style: 'Arial, Helvetica, sans-serif'
    };
    const isReadOnly =
        publicForCustomer == 2
        || props.viewFromProjectOfEscalateTicket
        || !Utils.isEmptyString(props.detailTicket?.deletedAt)
        || props.hasEditFieldPermissions == false;

    

    return ( 
        <div className="form-addTicket field-richtext">
            <LoadingPanel isLoading={isLoadingUploadFile}/>
            <div className="cell-prod-status gap-8">
                { props?.isTooltipTitle ?
                    (<div className="d-flex">
                        <Tooltip title={props?.label}>
                            <span className="form-addTicket-label text-truncate">
                                <label 
                                    className={
                                        'text-truncate line-height-18' + 
                                        (publicForCustomer 
                                            ? ' form-addTicket-label-color' 
                                            : ' form-addTicket-label'
                                        ) + 
                                        ' w-f100'
                                    }
                                >
                                    {props?.label}
                                </label>
                            </span>
                        </Tooltip>
                        {props.data.structure.required && (
                            <span className="required padding-left-4">*</span>
                        )}
                        </div>
                    ) : (
                    <label
                        className={
                            (publicForCustomer 
                                ? 'form-addTicket-label-color' 
                                : 'form-addTicket-label'
                            ) + 
                            ' w-f100'
                        }
                    >
                        {props?.label}{' '}
                        {props.data.structure.required && (
                            <span className="required">*</span>
                        )}
                    </label>
                    )
                }

                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>

            <div className="form-addTicket-input">
                <div
                    id={`ckbox-${ckEditorId}`}
                    data-cy="richtext-editor"
                    className={`
                    editor 
                    ${isReadOnly ? 'sdesk-editor editor-view ckeditor5-readonly ' : 'sdesk-editor'}
                    ${errMsg ? ' editor-err ' : ''}
                    `}
                >
                    {
                        (typeof window?.CKEDITOR?.ClassicEditor != 'undefined')
                        &&
                        <CKEditor
                            id={props?.parentForm?.id}
                            editor={window.CKEDITOR.ClassicEditor}
                            data={ckEditorState}
                            config={editorConfiguration}
                            onChange={handleOnChangeCKEditor}
                            onReady={(editor) => {
                                setSelftCKEditor5(editor);
                                editor.ui.view.toolbar.element.style.display = 'none';
                                
                                // Save original ContextualBalloon methods for later restore
                                try {
                                    const contextualBalloon = editor.plugins.get('ContextualBalloon');
                                    if (contextualBalloon && !contextualBalloonOriginalMethods.current) {
                                        contextualBalloonOriginalMethods.current = {
                                            showStack: contextualBalloon.showStack.bind(contextualBalloon),
                                            add: contextualBalloon.add.bind(contextualBalloon)
                                        };
                                    }
                                } catch (e) {
                                    // Plugin may not exist
                                }
                                
                                if (isReadOnly) {
                                    editor.enableReadOnlyMode(editor.id);
                                }

                                // Init fontSize default
                                // const fontSize = editor.commands.get('fontSize')
                                // fontSize.execute({value: '14px'})


                                // Init fontFamily default
                                // const fontFamily = editor.commands.get('fontFamily');
                                // fontFamily.execute({value: 'Arial, Helvetica, sans-serif'});
                                // editor.execute( 'fontSize', { value: '14px' } );
                                // editor.execute( 'fontFamily', { value: 'Arial, Helvetica, sans-serif' } );
                                

                                // editor.model.document.on( 'change', (event, editorData) => {
                                //     if (isReadOnly) return;
                                //     handleOnChangeCKEditor(event, editor);
                                // } );
                            }}
                            onFocus={(event, editor) => {
                                window.editor = editor;
                                document.querySelectorAll(`.editor .ck.ck-sticky-panel__content > .ck.ck-toolbar[aria-label="Editor toolbar"]`).forEach(el => {
                                    el.style.display = 'none';
                                });
                                editor.ui.view.toolbar.element.style.display = 'block';
                            }}
                        />
                    }
                </div>
                {errMsg && <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">{errMsg}</p>}
            </div>
        </div>
    );
}

